'use strict';

/**
 * Formato de valores numéricos para el render del inventario.
 *
 * Decisión de diseño: el separador de miles NO es global — se activa por
 * campo del fields_schema (`field.miles === true`). Algunos numéricos
 * lo necesitan (kilometraje: 20.000); otros no (4 últimos dígitos VISA:
 * 1234; año: 2024).
 *
 * useGrouping: 'always' obliga a Intl a agrupar también números de 4
 * dígitos. Sin él, 1234 → "1234" (Intl agrupa solo de 5 dígitos en
 * adelante en es-ES con la opción "min2").
 *
 * Forma CommonJS para poder reutilizar el helper desde tests con Node sin
 * configurar un loader ESM. CRA/webpack lo importan sin problema con
 * `import { formatNumberField } from '.../formatNumberField'`.
 */

const ES_FORMATTER = new Intl.NumberFormat('es-ES', { useGrouping: 'always' });

function formatNumberField(value, opts) {
  const o = opts || {};
  if (value === null || value === undefined || value === '') return '—';
  const num = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(num)) return String(value);
  if (o.miles) return ES_FORMATTER.format(num);
  return String(value);
}

module.exports = { formatNumberField };
